'use strict';

/**
 * Normalises the `/api/sso/provider` response into a list of sign-in options.
 *
 * Newer Alpha returns `{ providerId, providers: [{ providerId, orgId, orgName }] }`;
 * older Alpha returns only `{ providerId }`. Either way the login screen wants
 * an array: empty → password sign-in, one entry → straight to SSO handoff,
 * several → let the user pick their organisation.
 */
const normaliseProviderOptions = (data) => {
  if (Array.isArray(data?.providers) && data.providers.length > 0) {
    return data.providers
      .filter((provider) => provider && provider.providerId)
      .map((provider) => ({
        providerId: provider.providerId,
        orgId: provider.orgId || null,
        orgName: provider.orgName || null
      }));
  }

  if (data?.providerId) {
    return [{ providerId: data.providerId, orgId: null, orgName: null }];
  }

  return [];
};

module.exports = { normaliseProviderOptions };
